import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Form from "../../../Utils/Form/Formik";
import { AddUser, adminWalletBalance } from "../../../Services/Admin/Addmin";
import { getAllClient } from "../../../Services/Superadmin/Superadmin";
import { getUserFromToken } from "../../../Utils/TokenVerify";
let CountryCodes = [
  { code: "+1", country: "USA" },
  { code: "+44", country: "UK" },
  { code: "+91", country: "India" },
  { code: "+61", country: "Australia" },
  { code: "+81", country: "Japan" },
  { code: "+49", country: "Germany" },
  { code: "+33", country: "France" },
  { code: "+86", country: "China" },
  { code: "+39", country: "Italy" },
  { code: "+7", country: "Russia" },
  // Add more country codes as needed
  { code: "+92", country: "Pakistan" },
  { code: "+880", country: "Bangladesh" },
  { code: "+966", country: "Saudi Arabia" },
  { code: "+971", country: "UAE" },
  { code: "+27", country: "South Africa" },
  { code: "+34", country: "Spain" },
  { code: "+55", country: "Brazil" },
  { code: "+52", country: "Mexico" },
  { code: "+82", country: "South Korea" },
  { code: "+60", country: "Malaysia" },
  { code: "+65", country: "Singapore" },
  { code: "+31", country: "Netherlands" },
  { code: "+46", country: "Sweden" },
  { code: "+41", country: "Switzerland" },
  { code: "+358", country: "Finland" },
  { code: "+353", country: "Ireland" },
  { code: "+64", country: "New Zealand" },
];
const AddUsers = () => {
  const navigate = useNavigate();
  const TokenData = getUserFromToken();
const permission =  JSON.parse(localStorage.getItem("market"));
  const [dollarPrice, setDollarPrice] = useState(0);
  const [checkdolarprice, setCheckdolarprice] = useState(0);

  const [getid, setGetid] = useState([]);

  const Role = TokenData?.Role;
  const user_id = TokenData?.user_id;

  const formik = useFormik({
    initialValues: {
      fullName: "",
      username: "",
      email: "",
      countryCode: "",

      phone: "",
      employee_id: "",
      Balance: "",
      password: "",
      confirmPassword: "",

      limit: "",
      selectedOption: "",
      inputValue: "",
      option_selling_permission: false,
      price_zero_status: false,
      hide_sell_button: false,
      option_status: false,
      trade_block_time: "",

    },

    validate: (values) => {
      let errors = {};
      if (!values.fullName) {
        errors.fullName = "Please Enter Full Name";
      }
      if (!values.username) {
        errors.username = "Please Enter Username";
      }
      if (!values.email) {
        errors.email = "Please Enter Email Address";
      } else if (!/^\S+@\S+\.\S+$/.test(values.email)) {
        errors.email = "Please enter a valid email address.";
      }
      if (!values.countryCode) {
        errors.countryCode = "Please select a country code";
      }
      if (!values.phone) {
        errors.phone = "Please Enter Phone Number";
      } else if (!/^\d{10}$/.test(values.phone)) {
        errors.phone = "Please enter a valid 10-digit phone number.";
      }
      if (!values.Balance) {
        errors.Balance = "Please Enter Balance";
      } else if (isNaN(values.Balance)) {
        errors.Balance = "Balance must be a number";
      }

      if (!values.password) {
        errors.password = "Please Enter Password";
      } else if (values.password.length < 6) {
        errors.password = "Password must be at least 6 characters";
      }
      if (!values.confirmPassword) {
        errors.confirmPassword = "Please Confirm Password";
      } else if (values.password !== values.confirmPassword) {
        errors.confirmPassword = "Passwords do not match";
      }

      if (!values.selectedOption) {
        errors.selectedOption = "Please select an option";
      }
      if (!values.inputValue) {
        errors.inputValue = "Please enter a value for the selected option";
      }

      if (!values.limit) {
        errors.limit = "Please enter a value for Limit";
      } else if (
        isNaN(values.limit) ||
        values.limit < 0 ||
        values.limit > 100
      ) {
        errors.limit = "Limit should be a number between 0 and 100";
      }

      return errors;
    },

    onSubmit: async (values, { setSubmitting }) => {
      const selectedOption = values.selectedOption;
      const data = {
        FullName: values.fullName,
        UserName: values.username.toString().toLowerCase(),
        Email: values.email.toString().toLowerCase(),
        PhoneNo: values?.countryCode + " " + values.phone,
        employee_id: user_id,
        Balance: values.Balance,
        password: values.password,
        parent_role: Role || "EMPLOYE",
        parent_id: getid,
        Role: "USER",
        limit: values.limit,
        tradeType: values.tradeType,
        trade_block_time: values.trade_block_time,

        [selectedOption]: values.inputValue,
        option_selling_permission: values.option_selling_permission,
        price_zero_status: values.price_zero_status,
        hide_sell_button: values.hide_sell_button,
        option_status: values.option_status ? 1 : 0,
      };

      setSubmitting(false);

      if (
        dollarPrice == 0 ||
        dollarPrice == null ||
        dollarPrice === Infinity ||
        isNaN(dollarPrice)
      ) {
        Swal.fire({
          title: "Alert",
          text: "Please updated Dollarprice",
          icon: "warning",
          timer: 1000,
          timerProgressBar: true,
        });
        setSubmitting(false);
        return;
      }
      setSubmitting(false);

      setSubmitting(false);

      try {
        const response = await AddUser(data);
        if (response.status) {
          Swal.fire({
            title: "User Added!",
            text: "User added successfully",
            icon: "success",
            timer: 1000,
            timerProgressBar: true,
          });
          setTimeout(() => {
            navigate("/employee/users");
          }, 1000);
        } else {
          Swal.fire({
            title: "Error!",
            text: response.message || "User add error",
            icon: "error",
            timer: 1000,
            timerProgressBar: true,
          });
        }
      } catch (error) {
        Swal.fire({
          title: "Error!",
          text: "Failed to add user. Please try again later.",
          icon: "error",
          timer: 3000,
          timerProgressBar: true,
        });
      }
    },
  });

  const getadminbalance = async () => {
    const data = { userid: getid };
    try {
      const response = await adminWalletBalance(data);

      setCheckdolarprice(response.dollarPriceDoc.dollarprice);
    } catch (error) { }
  };

  const getallclient = async () => {
    try {
      const data = { userid: user_id };
      const response = await getAllClient(data);
      if (response.status) {
        setGetid(response.data.parent_id);
      }
    } catch (error) { }
  };

  useEffect(() => {
    getadminbalance();
    getallclient();
  }, [getid]);

  useEffect(() => {
    const exchangeRate = Number(checkdolarprice);
    setDollarPrice(
      formik.values.Balance
        ? parseFloat(formik.values.Balance) / exchangeRate
        : 0
    );
  }, [formik.values.Balance]);

  const fields = [
    {
      name: "fullName",
      label: "Full Name",
      type: "text",
      label_size: 6,
      col_size: 6,
      disable: false,
    },
    {
      name: "username",
      label: "Username",
      type: "text",
      label_size: 12,
      col_size: 6,
      disable: false,
    },
    {
      name: "countryCode",
      label: "Country Code",
      type: "select",
      options: CountryCodes.map((c) => ({
        label: `${c.country} (${c.code})`,
        value: c.code,
      })),
    },
    {
      name: "phone",
      label: "Phone Number",
      type: "text3",
      label_size: 12,
      col_size: 6,
      disable: false,
    },
    {
      name: "email",
      label: "Email",
      type: "text",
      label_size: 12,
      col_size: 6,
      disable: false,
    },
    {
      name: "Balance",
      label: "Balance",
      type: "text",
      label_size: 12,
      col_size: 6,
      disable: false,
    },
    {
      name: "password",
      label: "Password",
      type: "password",
      label_size: 12,
      col_size: 6,
      disable: false,
    },
    {
      name: "confirmPassword",
      label: "Confirm Password",
      type: "password",
      label_size: 12,
      col_size: 6,
      disable: false,
    },
    {
      name: "limit",
      label: "Intraday Margin(0-100%)",
      type: "text3",
      label_size: 12,
      col_size: 6,
      disable: false,
    },
    {
      name: "limit",
      label: "Holding Margin(0-100%)",
      type: "text3",
      label_size: 12,
      col_size: 6,
      disable: false,
    },

    {
      name: "selectedOption",
      label: "Brokerage",
      type: "select",
      options: [
        { value: "pertrade", label: "Per Trade" },
        { value: "perlot", label: "Per Lot" },
      ],
      label_size: 12,
      col_size: 6,
      disable: false,
    },
    ...(formik.values.selectedOption
      ? [
        {
          name: "inputValue",
          label:
            formik.values.selectedOption === "pertrade"
              ? "Per Trade"
              : "Per Lot",
          type: "text",
          label_size: 12,
          col_size: 6,
          disable: false,
        },
      ]
      : []),
    {
      name: "tradeType",
      label: "Client Trade Type",
      type: "select",
      options: [
        { value: 0, label: "Fund Wise" },
        { value: 1, label: "Per Trade" },
      ],
      label_size: 12,
      col_size: 6,
    },

    
    ...(permission?.includes(0) ? [
 {
      name: "option_selling_permission",
      label: "Forex Option Selling Permission",
      type: "toggle",
      col_size: 6,
    },
    {
      name: "option_status",
      label: "Forex Option Chain Price Zero Permission",
      type: "toggle",
      col_size: 6,
    },
    ] : []),
   

...(permission?.includes(1) ? [
    {
      name: "hide_sell_button",
      label: "INR Hide Sell Button",
      type: "toggle",
      col_size: 6,
    },

    {
      name: "price_zero_status",
      label: "INR Zero price Status",
      type: "toggle",
      col_size: 6,
    },
  ] : []),
  ];

  return (
    <div>
      <Form
        fields={fields}
        page_title="Add User"
        btn_name="Add User"
        btn_name1="Cancel"
        formik={formik}
        btn_name1_route={"/employee/users"}
        additional_field={

          <div className="col-lg-6 mt-4">
            <div className="mb-3 ">
              <label className="fw-bold">Trade Block Duration</label>
              <input
                type="text"
                className="form-control"
                placeholder="mm:ss"
                value={formik.values.trade_block_time || ""}
                onChange={(e) => {
                  let value = e.target.value;

                  // Auto-format only mm:ss allowed
                  if (/^[0-9]{0,2}(:[0-9]{0,2})?$/.test(value)) {
                    formik.setFieldValue("trade_block_time", value);
                  }
                }}
              />
              <small className="text-muted">Format: mm:ss (Example: 05:30)</small>
            </div>
          </div>
        }
      />

    </div>
  );
};

export default AddUsers;
